import { formatDate } from '@shared/services/dateService';

const CalendarMapper = {
  toCalendarData: events => {
    return events.map(item => {
      return {
        id: item.Id,
        eventId: item.EventId,
        start: formatDate(new Date(item.Start)),
        end: formatDate(new Date(item.End))
      };
    });
  },
  toApolloAddInput: week => {
    return {
      Start: week.start
    };
  }
};

export default CalendarMapper;
